import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type PartsDeliveryQuoteMutationVariables = Types.Exact<{
  pickup: Types.PartsDeliveryPointInput;
  dropoff: Types.PartsDeliveryPointInput;
  items: Array<Types.PartsDeliveryItemInput> | Types.PartsDeliveryItemInput;
  manifestTotalValueCents?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  readyAt?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PartsDeliveryQuoteMutation = { __typename?: 'mutation_root', partsDeliveryQuote?: { __typename?: 'PartsDeliveryQuoteOutput', quotes: Array<{ __typename?: 'PartsDeliveryQuoteResult', vendor: string, quoteId: string, feeCents: number, currency: string, pickupEta?: string | null, dropoffEta?: string | null, expiresAt?: string | null }>, errors: Array<{ __typename?: 'PartsDeliveryQuoteError', vendor: string, message: string }> } | null };


export const PartsDeliveryQuoteDocument = gql`
    mutation partsDeliveryQuote($pickup: PartsDeliveryPointInput!, $dropoff: PartsDeliveryPointInput!, $items: [PartsDeliveryItemInput!]!, $manifestTotalValueCents: Int, $readyAt: String) {
  partsDeliveryQuote(
    pickup: $pickup
    dropoff: $dropoff
    items: $items
    manifestTotalValueCents: $manifestTotalValueCents
    readyAt: $readyAt
  ) {
    quotes {
      vendor
      quoteId
      feeCents
      currency
      pickupEta
      dropoffEta
      expiresAt
    }
    errors {
      vendor
      message
    }
  }
}
    `;
export type PartsDeliveryQuoteMutationFn = Apollo.MutationFunction<PartsDeliveryQuoteMutation, PartsDeliveryQuoteMutationVariables>;

/**
 * __usePartsDeliveryQuoteMutation__
 *
 * To run a mutation, you first call `usePartsDeliveryQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartsDeliveryQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partsDeliveryQuoteMutation, { data, loading, error }] = usePartsDeliveryQuoteMutation({
 *   variables: {
 *      pickup: // value for 'pickup'
 *      dropoff: // value for 'dropoff'
 *      items: // value for 'items'
 *      manifestTotalValueCents: // value for 'manifestTotalValueCents'
 *      readyAt: // value for 'readyAt'
 *   },
 * });
 */
export function usePartsDeliveryQuoteMutation(baseOptions?: Apollo.MutationHookOptions<PartsDeliveryQuoteMutation, PartsDeliveryQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartsDeliveryQuoteMutation, PartsDeliveryQuoteMutationVariables>(PartsDeliveryQuoteDocument, options);
      }
export type PartsDeliveryQuoteMutationHookResult = ReturnType<typeof usePartsDeliveryQuoteMutation>;
export type PartsDeliveryQuoteMutationResult = Apollo.MutationResult<PartsDeliveryQuoteMutation>;
export type PartsDeliveryQuoteMutationOptions = Apollo.BaseMutationOptions<PartsDeliveryQuoteMutation, PartsDeliveryQuoteMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/partsDeliveryQuote.mutation.gql}
 */
export async function partsDeliveryQuote(
  variables: PartsDeliveryQuoteMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<PartsDeliveryQuoteMutation['partsDeliveryQuote']>
export async function partsDeliveryQuote(
  variables: PartsDeliveryQuoteMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<PartsDeliveryQuoteMutation>
export async function partsDeliveryQuote(
  variables: PartsDeliveryQuoteMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<PartsDeliveryQuoteMutation['partsDeliveryQuote'] | PartsDeliveryQuoteMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<PartsDeliveryQuoteMutation>(
    PartsDeliveryQuoteDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.partsDeliveryQuote
}